"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FundraisingEventTeaser = void 0;
var _react = _interopRequireDefault(require("react"));
var _format_amount = require("../helpers/format_amount");
var _trusted_html = require("./trusted_html");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var pluralizeDonation = function pluralizeDonation(locale, count) {
  if (count === 1) return locale === 'de' ? 'Spende' : 'donation';
  return locale === 'de' ? 'Spenden' : 'donations';
};
var FundraisingEventTeaser = exports.FundraisingEventTeaser = function FundraisingEventTeaser(_ref) {
  var _find, _fundraisingEvent$pro, _fundraisingEvent$con, _fundraisingEvent$con2, _fundraisingEvent$con3, _fundraisingEvent$con4;
  var fundraisingEvent = _ref.fundraisingEvent,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? document.documentElement.lang || 'de' : _ref$locale,
    href_ = _ref.href,
    onClick = _ref.onClick,
    openInTab = _ref.openInTab,
    children = _ref.children;
  var href = href_ || ((_find = fundraisingEvent.links.find(function (link) {
    return link.rel === 'platform';
  })) === null || _find === void 0 ? void 0 : _find.href);
  var fundraisingEventImageUrl = (_fundraisingEvent$pro = fundraisingEvent.profile_picture) === null || _fundraisingEvent$pro === void 0 || (_fundraisingEvent$pro = _fundraisingEvent$pro.links.find(function (link) {
    return link.rel === 'fill_410x214';
  })) === null || _fundraisingEvent$pro === void 0 ? void 0 : _fundraisingEvent$pro.href;
  var donationsAmount = (0, _format_amount.formatAmount)({
    cents: fundraisingEvent.donated_amount_in_cents,
    locale: locale
  });
  var contactImageUrl = (_fundraisingEvent$con = fundraisingEvent.contact) === null || _fundraisingEvent$con === void 0 || (_fundraisingEvent$con = _fundraisingEvent$con.picture) === null || _fundraisingEvent$con === void 0 || (_fundraisingEvent$con = _fundraisingEvent$con.links.find(function (link) {
    return link.rel === 'fill_100x100';
  })) === null || _fundraisingEvent$con === void 0 ? void 0 : _fundraisingEvent$con.href;
  var handleClick = function handleClick(event) {
    onClick && onClick(event, fundraisingEvent);
  };
  var donationsTxt = pluralizeDonation(locale, fundraisingEvent.donations_count);
  return /*#__PURE__*/_react["default"].createElement("a", {
    title: fundraisingEvent.title,
    onClick: handleClick,
    className: "donatable-teaser",
    href: href,
    target: openInTab ? '_blank' : '_parent',
    rel: "noreferrer"
  }, children /* mount point, e.g. for injecting VisibilitySensor */, /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--profile-picture",
    style: {
      backgroundImage: "url(".concat(fundraisingEventImageUrl, ")")
    },
    title: fundraisingEvent.title
  }), /*#__PURE__*/_react["default"].createElement(_trusted_html.TrustedHtml, {
    as: "h2",
    className: "donatable-teaser--title",
    value: fundraisingEvent.title
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--divider"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "donatable-teaser--factlist"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_trusted_html.TrustedHtml, {
    as: "span",
    value: (_fundraisingEvent$con2 = fundraisingEvent.contact) === null || _fundraisingEvent$con2 === void 0 ? void 0 : _fundraisingEvent$con2.name
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, fundraisingEvent.donations_count), " ", donationsTxt), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, donationsAmount), " ", locale === 'de' ? 'gesammelt' : 'collected')), /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      borderRadius: '50%',
      border: '1px solid #cccccc'
    },
    src: contactImageUrl,
    alt: (_fundraisingEvent$con3 = (_fundraisingEvent$con4 = fundraisingEvent.contact) === null || _fundraisingEvent$con4 === void 0 ? void 0 : _fundraisingEvent$con4.name) !== null && _fundraisingEvent$con3 !== void 0 ? _fundraisingEvent$con3 : '',
    className: "donatable-teaser--carrier-logo"
  })));
};